module.exports = __webpack_public_path__ + "img/Bingo2_Info_Game_2.e75273d0.png";